// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"676666e9","407":"ee09ae04","498":"249a3a8e","741":"f1dc5a75","940":"854086f9"}[chunkId] + ".chunk.js";
};